import { observer } from "mobx-react";
import React from "react";

import { useMainStore } from "@/contexts/Store";

import checkGrayIcon from "../../../images/table-image/check-gray-icon.svg";
import checkIcon from "../../../images/table-image/icon/check-two-icon.svg";

type Props = {
  disabled?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onClick?: (...args: any[]) => any;
  showIcon?: boolean;
};

function ApproveButton({ onClick, disabled, showIcon }: Props) {
  const mainStore = useMainStore();

  const { hasModuleWriteAccess } = mainStore.userPermissions;
  const isDisabled = !hasModuleWriteAccess || disabled;

  return (
    <button
      className="approve"
      onClick={onClick}
      data-testid="approve-button"
      disabled={isDisabled}
    >
      {showIcon && !isDisabled && (
        <img src={checkIcon} alt="check-icon" data-testid="check-icon" />
      )}
      {showIcon && isDisabled && (
        <img
          src={checkGrayIcon}
          alt="check-icon"
          data-testid="check-gray-icon"
        />
      )}
      Approve
    </button>
  );
}

ApproveButton.defaultProps = {
  disabled: false,
  showIcon: true,
};

export default observer(ApproveButton);
